import { AbstractCameraCaptureAdapter } from './AbstractCameraCaptureAdapter';
import { VelocityCameraCaptureAdapter } from './VelocityCameraCaptureAdapter';
import { CrossFrameCameraCaptureAdapter } from './CrossFrameCameraCaptureAdapter';
import { EnvironmentDetail } from '@src/utils';

export class CameraCaptureAdapterProvider {
    private static instance: AbstractCameraCaptureAdapter;

    public static get(): AbstractCameraCaptureAdapter {
        if (!CameraCaptureAdapterProvider.instance) {
            if (EnvironmentDetail.isVelocityBrowser(window)) {
                CameraCaptureAdapterProvider.instance = new VelocityCameraCaptureAdapter();
            } else {
                CameraCaptureAdapterProvider.instance = new CrossFrameCameraCaptureAdapter();
            }
        }
        return CameraCaptureAdapterProvider.instance;
    }
}
